

































































































import QuoteStateMixin from '@/mixins/quoteState';
import { mapActions, mapGetters } from 'vuex';

import { ErrorManager } from '@/models/error';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { IQuoteData, Quote, QuoteFieldError } from '@/models';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import QuoteDocumentBuilderDialog from '@/components/quotes/QuoteDocumentBuilderDialog.vue';
import QuoteCreateSalesOpportunityListItem from '../QuoteCreateSalesOpportunityListItem.vue';
import QuoteGenerateOrderReviewListItem from '../QuoteGenerateOrderReviewListItem.vue';

const baseMixins = mixins(QuoteStateMixin, auth);

export default baseMixins.extend({
  components: {
    ErrorAlert,
    QuoteDocumentBuilderDialog,
    QuoteCreateSalesOpportunityListItem,
    QuoteGenerateOrderReviewListItem
  },
  name: 'QuoteOrderCreatedStateCard',

  computed: {
    ...mapGetters({
      getQuoteById: 'quote/getQuoteById'
    }),

    getColor(): string {
      return 'closed';
    },

    getIcon(): string {
      return 'mdi-thumb-up-outline';
    },

    getString(): string {
      return 'Order Created';
    }
  },

  data: () => ({
    loading: false,

    fieldError: new QuoteFieldError()
  }),

  methods: {
    ...mapActions({
      createQuoteRevision: 'quote/createQuoteRevision'
    }),

    async createRevision(quoteData: IQuoteData) {
      this.clearAllErrors();
      this.loading = true;

      return this.createNewQuoteRevision(quoteData).catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
          if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
            this.fieldError = new QuoteFieldError(error.response.data);
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
        //because the page is reloaded there's no need to reset loading flag on finally
        this.loading = false;
      });
    }
  }
});
